module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/home-category-171-3bac5b.svg";